import React, { Component } from 'react';
import { acessoPermitido } from '../../../acessos.seguranca';
import ProtocoloPage from '@common/protocolo/protocolo.page';
import WebapiCommon from '@common/util/webapi.common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import ProtocoloAPI from './protocolo.api';
import LaminaApi from '@common/requisicaoCongelacao/tabs/lamina/lamina.api';
import ConfiguracaoApi from '../../../pages/configuracao/configuracao.api';

class ProtocoloContainer extends Component {
  constructor(props) {
    super(props);
    this.selectAnticorposRef = React.createRef();
    this.state = {
      listagemBlocos: [],
      listagemGrupoAnticorpos: [],
      blocoSelecionado: undefined,
      grupoAnticorposSelecionado: undefined,
      listaAnticorposFiltro: [],
      material: undefined,
      frasco: undefined,
      numeroExame: null,
      configuracaoVentana: null,
      ventanaList: [],
      numeroExameExterno: null,
      exameExterno: false,
      selectedDestino: null,
      numeroExameAnterior: null,
      listagemProtocolos: [],
      reagentesSelecionados: [],
      reagentesCadastrados: [],
      laudo: null,
      laudoAnterior: null,
      medicos: [],
      medicoselecionado: null,
      activeTab: '1',
      anticorpos: '',
      novosregistros: [],
      modalAnticorpoJaLancado: {
        show: false,
      },
    };
  }

	getVentanaList = () => {
		LaminaApi.obterVentana(this.state.laudo).then((res)=>{
			this.setState({
        ventanaList: res.data,
      });
    })
  }

  sendVentana = () => {
    this.props.commonActions.showFadeCarregando(true);
    LaminaApi.enviarLaminaVentana({ laudo: this.state.laudo }).then((res) => {
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.showAlerta(
        'sucesso',
        res.message,
        2000,
        res.message.length * 10 + 'px'
      );

      this.props.commonActions.showeModalImuno(false);

    }).catch(() => {
      this.props.commonActions.showFadeCarregando(false);
    })
  }

  verifyAnticorpos = () => {
    const grupo = this.state.grupoAnticorposSelecionado;
    let isActive = false;
    if (grupo && grupo.label) {
      isActive =
        grupo.label.indexOf('IHC') >= 0 || grupo.label.indexOf('H-C') >= 0;
    }
    return isActive;
  };

  render() {
    const destinos = [
      { value: 2, label: 'Histologia Lâmina' },
      { value: 3, label: 'Imunologia Lâmina' },
    ];

    const formatGroupLabel = (data) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span
          onClick={() => this.selecionarAnticorposPorGrupo(data.label)}
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: '#000',
          }}
        >
          {data.label}
        </span>
      </div>
    );

    return (
      <ProtocoloPage
        verifyAnticorpos={this.verifyAnticorpos.bind(this)}
        atualizarDestino={this.atualizarDestino.bind(this)}
        selectedDestino={this.state.selectedDestino}
        destinos={destinos}
        usuario={this.props.usuario}
        acessoPermitido={acessoPermitido}
        exameExterno={this.state.exameExterno}
        configuracaoVentana={this.state.configuracaoVentana}
        ventanaList={this.state.ventanaList}
        listagemBlocos={this.state.listagemBlocos}
        listagemProtocolos={this.state.listagemProtocolos}
        listaAnticorposFiltro={this.state.listaAnticorposFiltro}
        formatGroupLabel={formatGroupLabel}
        bloco={this.state.blocoSelecionado}
        grupo={this.state.grupoAnticorposSelecionado}
        anticorpos={this.state.anticorpos}
        listagemGrupoAnticorpos={this.state.listagemGrupoAnticorpos}
        material={this.state.material}
        frasco={this.state.frasco}
        numeroExame={this.state.numeroExame}
        numeroExameExterno={this.state.numeroExameExterno}
        numeroExameAnterior={this.state.numeroExameAnterior}
        laudoAnterior={this.state.laudoAnterior}
        reagentesSelecionados={this.state.reagentesSelecionados}
        reagentesCadastrados={this.state.reagentesCadastrados}
        removerAnticorposLista={this.removerAnticorposLista.bind(this)}
        removerLaminaLista={this.removerLaminaLista.bind(this)}
        selecaoBloco={this.selecaoBloco.bind(this)}
        sendVentana={this.sendVentana.bind(this)}
        selecaoAnticorposPorGrupo={this.selecaoAnticorposPorGrupo.bind(this)}
        selecaoProtocolo={this.selecaoProtocolo.bind(this)}
        selecaoProtocoloBefore={this.selecaoProtocoloBefore.bind(this)}
        adicionarRequisicaoProtocolo={this.adicionarRequisicaoProtocolo.bind(
          this
        )}
        selectAnticorposRef={this.selectAnticorposRef}
        medicos={this.state.medicos}
        medicoselecionado={this.state.medicoselecionado}
        stateUpdate={this.stateUpdate.bind(this)}
        limparAnticorposSelecionados={this.limparAnticorposSelecionados.bind(
          this
        )}
        activeTab={this.state.activeTab}
        toggle={this.toggle.bind(this)}
        novosregistros={this.state.novosregistros}
        modalAnticorpoJaLancado={this.state.modalAnticorpoJaLancado}
        toggleModalAnticorpoJaLancado={this.toggleModalAnticorpoJaLancado.bind(
          this
        )}
        setFavoritos={this.setFavoritos.bind(this)}
      />
    );
  }

  componentDidMount() {
    let laudo = !this.props.laudo
      ? this.props.detalhes.laudo
      : this.props.laudo;
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      WebapiCommon.dadosTelaRequisicaoAnticorpos(laudo),
      WebapiCommon.getAnticorpos(),
      WebapiCommon.getMedicos(),
      WebapiCommon.getLaminasImuno(laudo),
      ConfiguracaoApi.getConfiguracaoGeral(),
      LaminaApi.obterVentana(laudo),
    ]).then((response) => {
      let dadosTelaRequisicaoAnticorposResponse = response[0];
      let getAnticorposResponse = response[1];
      let getMedicosResponse = response[2];
      let getLaminasImunoResponse = response[3];
      let getConfiguracaoVentana = response[4];
      let getVentanaList = response[5];

      let dadosExameRequisicaoAnticorpos =
        dadosTelaRequisicaoAnticorposResponse.data
          .dadosExameRequisicaoAnticorpos;
      let blocoParaRequisicaoAnticorpos =
        dadosTelaRequisicaoAnticorposResponse.data
          .blocoParaRequisicaoAnticorpos;

      let reagentesCadastrados = this.getReagentesCadastrados(
        getLaminasImunoResponse
      );

      let exameExterno =
        dadosTelaRequisicaoAnticorposResponse.data
          .dadosExameRequisicaoAnticorpos.exameExterno;

      this.setState({ exameExterno });

      let listagemBlocos = blocoParaRequisicaoAnticorpos.map((el) => ({
        value: el.idLaudoBloco,
        label: el.bloco,
        material: el.material,
        frasco: el.frasco,
      }));

      let listagemProtocolos = [];
      let listagemGrupos = [];
      getAnticorposResponse.data.forEach((el) => {
        let item = listagemProtocolos.find((e) => e.label === el.tipo);
        if (item) {
          item.options.push({
            value: el.value,
            label: el.label,
            tipo: el.tipo,
          });
        } else {
          listagemGrupos.push({ value: el.value, label: el.tipo });
          listagemProtocolos.push({
            label: el.tipo,
            options: [
              {
                value: el.value,
                label: el.label,
                tipo: el.tipo,
              },
            ],
          });
        }
      });

      let item = '{"value": -1, "label": "Selecionar tipo"}';
      listagemGrupos.splice(0, 0, JSON.parse(item));

      let usuarioLocalStorage = getUsuarioLocalStorage();
      let medicoselecionado;

      if (usuarioLocalStorage && usuarioLocalStorage.medico) {
        medicoselecionado = {
          value: usuarioLocalStorage.medicoId,
          label:
            usuarioLocalStorage.medicoId + ' - ' + usuarioLocalStorage.medico,
        };
      }

      this.setState({
        laudo,
        numeroExame: dadosExameRequisicaoAnticorpos.nrExame,
        listagemBlocos: listagemBlocos,
        numeroExameExterno: dadosExameRequisicaoAnticorpos.nrExameExterno,
        numeroExameAnterior: dadosExameRequisicaoAnticorpos.nrExameAnterior,
        laudoAnterior: dadosExameRequisicaoAnticorpos.laudoAnterior,
        listagemProtocolos: listagemProtocolos,
        medicos: getMedicosResponse,
        medicoselecionado,
        reagentesCadastrados,
        listagemGrupoAnticorpos: listagemGrupos,
        ventanaList: getVentanaList.data,
        configuracaoVentana: getConfiguracaoVentana.snIntegrarVentana == 'S'
      });

      this.props.commonActions.showFadeCarregando(false);
    });
  }

  getReagentesCadastrados(getLaminasImunoResponse) {
    return getLaminasImunoResponse.map((lamina) => ({
      id: lamina.cdRequisicao,
      nome: lamina.medId + ' - ' + lamina.nome,
      bloco: lamina.nrBloco,
      lamina: lamina.dsCasoLamina,
      anticorpo: lamina.anticorpo,
      cdAnticorpo: lamina.cdAnticorpo,
      tipo: lamina.tipo,
    }));
  }

  selecaoBloco(bloco) {
    this.setState({
      material: bloco.material,
      frasco: bloco.frasco,
      blocoSelecionado: bloco,
    });
  }

  atualizarDestino(value) {
    this.setState({ selectedDestino: value });
  }

  selecaoAnticorposPorGrupo(grupo) {
    if (grupo.value > -1) {
      let item = this.state.listagemProtocolos.find(
        (e) => e.label === grupo.label
      );
      this.setState({
        grupoAnticorposSelecionado: grupo,
        listaAnticorposFiltro: item,
        anticorpos: '',
      });
    } else {
      this.setState({
        grupoAnticorposSelecionado: undefined,
        anticorpos: '',
      });
    }
  }

  removerAnticorposLista(index) {
    let reagentes = this.state.reagentesSelecionados;
    reagentes.splice(index, 1);

    if (index > -1) {
      this.setState({
        reagentesSelecionados: reagentes,
      });
    }
  }
  removerLaminaLista(id, index) {
    let laminas = this.state.reagentesCadastrados;
    const laudo = this.state.laudo;
    const requisicao = id;

    if (requisicao && laudo && laminas) {
      laminas.splice(index, 1);

      if (index > -1) {
        this.setState({
          reagentesCadastrados: laminas,
        });
        ProtocoloAPI.ApagarRequisicaoImuno(laudo, requisicao).then(()=>{
					this.getVentanaList();
				})

      }
    }
  }

  selecaoProtocoloBefore(protocolo) {
    this.setState({
      anticorpos: undefined,
    });
    let { reagentesCadastrados } = this.state;
    if (
      reagentesCadastrados.findIndex(
        (el) => el.cdAnticorpo === protocolo.value
      ) > -1
    ) {
      this.setState({
        modalAnticorpoJaLancado: {
          show: true,
          protocolo,
        },
      });
    } else {
      this.selecaoProtocolo(protocolo);
    }
  }

  selecaoProtocolo = (protocolo) => {

    this.setState((state) => ({
      reagentesSelecionados: [
        ...state.reagentesSelecionados,
        {
          bloco: state.blocoSelecionado,
          protocolo: protocolo,
        },
      ],
      modalAnticorpoJaLancado: {
        show: false,
      },
    }));
  }

  selecionarAnticorposPorGrupo(grupo) {
    const { listagemProtocolos } = this.state;
    let anticorposDoGrupo = listagemProtocolos.find((el) => el.label === grupo);
    if (anticorposDoGrupo) {
      anticorposDoGrupo.options.forEach((el) => this.selecaoProtocolo(el));
      this.selectAnticorposRef.current.blur();
    }
  }

  adicionarRequisicaoProtocolo() {

    this.props.commonActions.showFadeCarregando(true);
    const {
      blocoSelecionado,
      laudo,
      medicoselecionado,
      reagentesSelecionados,
      reagentesCadastrados,
    } = this.state;

    let usuarioLocalStorage = getUsuarioLocalStorage();

    let laminas = reagentesSelecionados.map((el) => ({
      lamina: 'Imuno',
      qtd: 1,
      cdAnticorpo: el.protocolo.value,
      destino: '0',
    }));

    if (this.state.selectedDestino) {
      laminas[0]['destino'] = this.state.selectedDestino.value;
    }

    var criarLaminaRequest = {
      nrBloco: blocoSelecionado.label,
      blocoID: blocoSelecionado.value,
      laudoID: laudo,
      medicoID: medicoselecionado.value,
      tecnicoID: usuarioLocalStorage.usuarioId,
      sentinelaMama: false,
      sentinelaMelanoma: false,
      complemento: '',
      laminas: laminas,
    };

    WebapiCommon.criarLamina(criarLaminaRequest).then(() => {
      WebapiCommon.getLaminasImuno(laudo).then((laminas) => {
				this.getVentanaList();
        let novosReagentesCadastrados = this.getReagentesCadastrados(laminas);
        let novosregistros = [...novosReagentesCadastrados];

        reagentesCadastrados.forEach((el) => {
          let posicao = novosregistros.findIndex((e) => e.id === el.id);
          if (posicao > -1) {
            novosregistros.splice(posicao, 1);
          }
        });

        this.setState({
          reagentesCadastrados: novosReagentesCadastrados,
          reagentesSelecionados: [],
          novosregistros,
        });

        this.toggle('2');
        this.props.commonActions.showAlerta(
          'sucesso',
          'Lâmina solicitada com sucesso',
          800
        );
        this.props.commonActions.showFadeCarregando(false);

        setTimeout(this.limparNovosRegistros, 4000);
      });
    });
  }

  setFavoritos(item) {
    let favorito = JSON.parse(item.favorito);

    this.setState({
      reagentesSelecionados: favorito
    });
  }

  stateUpdate = (name, value) =>
    this.setState({
      [name]: value,
    });

  limparAnticorposSelecionados = () =>
    this.setState({
      reagentesSelecionados: [],
      anticorpos: '',
      grupoAnticorposSelecionado: '',
    });

  toggle = (activeTab) => this.setState({ activeTab });

  limparNovosRegistros = () => this.setState({ novosregistros: [] });

  toggleModalAnticorpoJaLancado = () => {
    let { modalAnticorpoJaLancado } = this.state;
    modalAnticorpoJaLancado.show = !modalAnticorpoJaLancado.show;
    this.setState({ modalAnticorpoJaLancado });
  };
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    protocolo: state.protocolo,
    modalRequisicaoImuno: state.commonReducer.modalRequisicaoImuno,
  };
};

const mapsDispacthToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapsDispacthToProps
)(ProtocoloContainer);




// WEBPACK FOOTER //
// ./src/app/common/protocolo/protocolo.container.js